<template>
  <div class="home">
    <!-- <div class="lang_toggle">
      <span :class="btnLangClass('pt')" @click="onPtPress">PT
      </span> | <span :class="btnLangClass('en')" @click="onEnPress">EN</span>
    </div> -->
    <img class="content__map" src="@/assets/bubuia_map.jpg" />
    <img class="content__index" src="@/assets/bubuia_index.jpg" />
  </div>
</template>

<script>
export default {
  name: 'BubuiaMap',
  components: {
  },
  data() {
    return {
      selectedLang: null, // 'en' or 'pt'
    };
  },
  created() {
    const locale = navigator.language || navigator.userLanguage;
    if (locale) {
      const lang = locale.split("-")[0]; // e.g. "en" or "pt"
      this.selectedLang = lang === 'pt' ? 'pt' : 'en';
    } else {
      this.selectedLang = 'en';
    }
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    btnLangClass(lang) {
      return {
        'lang_toggle__link': true,
        'lang_toggle__link--active': this.selectedLang === lang
      };
    },
    onEnPress() {
      this.selectedLang = "en";
      this.changeVideo();
    },
    onPtPress() {
      this.selectedLang = "pt";
      this.changeVideo();
    },
  }
}
</script>

<style lang="scss" scoped>
// .video-container {
//   position: relative;
//   width: 100%;
//   padding-bottom: 56.25%;
//   /* 16:9 aspect ratio */
//   height: 0;
//   overflow: hidden;
// }

// .video-container iframe {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   border: 0;
// }

.home {
  width: 100%;
  padding-left: $content-padding;
  padding-right: $content-padding;
  padding-bottom: $content-padding;
  max-width: 700px;
}

.content {
  &__title {
    font-family: $base-font-family;
    font-size: 1rem !important;
    line-height: 1.4 !important;
    // font-weight: 600;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 30px;
  }

  &__text {
    font-family: $base-font-family;
    font-size: 0.8rem !important;
    line-height: 1.3 !important;
    margin-top: 30px;
    text-align: left; //justify;
  }

  &__map {
    width: 100%;
    max-width: 900px;
    margin-top: 30px;
  }

  &__index {
    width: 100%;
    max-width: 900px;
    margin-bottom: 20px;
  }
}

.lang_toggle {
  display: flex;
  margin-bottom: 2 * $content-padding;
  color: #cccccc;
  align-items: center;
  justify-content: center;

  &__link {
    font-family: $base-font-family;
    font-size: 0.88rem !important;
    color: #cccccc;
    cursor: pointer;
    text-decoration: none;
    padding: 8px 6px;

    &:hover {
      text-decoration: underline;
      // color: $theme-color-primary;
      // color: darken($theme-color-primary, 10%);
    }

    &--active {
      // font-weight: 600;
      color: #666666;
      cursor: default;

      &:hover {
        text-decoration: none;
        // color: $theme-color-primary;
        // color: darken($theme-color-primary, 10%);
      }
    }
  }
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  /* 16:9 ratio */
  height: 0;
}

::v-deep #player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.timestamps {
  list-style: none;
  padding: 0;
  text-align: left;
}

.timestamps li {
  font-family: $base-font-family;
  font-size: 1rem !important;
  margin-bottom: 0.2rem;
}

.timestamps button {
  font-family: $base-font-family;
  background: none;
  border: none;
  color: $theme-color-primary;
  font-size: 0.9rem;
  cursor: pointer;
  text-align: left;
  padding: 0;
  padding-top: 6px;
  padding-bottom: 6px;
  min-width: 50px;
}

.timestamps button:hover {
  text-decoration: underline;
}
</style>
